import React, { Component } from 'react';
import { connect } from 'react-redux';
import FachgebieteComponent from '../components/FachgebieteSelect';
import {selectFachgebiet as selectFachgebietAction} from "../actions/fachgebiete";
import {RESET} from "../types/filters";
class FachgebieteSelect extends Component
{
    render() {
        return <div>
            <FachgebieteComponent selected={this.props.selected} selectFachgebiet={this.selectFachgebiet.bind(this)}/>
        </div>
    }

    selectFachgebiet(id) {
        this.props.dispatch(selectFachgebietAction(id));
        this.props.dispatch({type: RESET});
    }
}

const mapStateToProps = store=>{
    return {
        selected: store.fachgebiete.selected
    }
}

export default connect(mapStateToProps)(FachgebieteSelect)



// WEBPACK FOOTER //
// ./src/containers/FachgebieteSelect.js